module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQ9JREFUOE/l1D8oRlEYx/HPy2S1kE29s9hlt2FSBiWFQRnUOxgwGJRBGVBSBmXCZpedzLdsYrGa/OnUObrd7nXvWzZneeqc53yf5/n9Oqflj1arhjOOw5izgruq/CpQL7awgYN4eRU7cf+jCCwDDeMCIS7hKl6axjGeMBvjD68Imsc+HjCH50LlIZxjFGs4S+cJ1IejWCmMs1ej3XocM3S+jPcEOsUEZvDY0MgRXOIWCwn0ElsNFbpZQasgxWACvUZhr7uhYCoaMJAHhVmTQ9rt9lcZNMuyvEHByaDtr6DNCtB2br8e1HDE/wS6QT92UepWiWbBvQ7eMJmsDG/oBGPoaSj0J+6xGN5k3X/UkMk3cUVBE0fe9lYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Shou.png
// module id = ksyR
// module chunks = 7